import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { logoutAdmin } from '../../services/firebase';
import { useAuth } from '../../context/AuthContext';

const NAV_ITEMS = [
  {
    section: 'Principale',
    items: [
      { to: '/dashboard',    label: 'Dashboard',       icon: 'grid' },
      { to: '/bookings',     label: 'Prenotazioni',    icon: 'calendar' },
      { to: '/beach',        label: 'Mappa Spiaggia',  icon: 'beach' },
    ],
  },
  {
    section: 'Configurazione',
    items: [
      { to: '/beach-builder', label: 'Beach Builder',  icon: 'builder' },
      { to: '/tariffe',       label: 'Tariffe',        icon: 'tag' },
      { to: '/settings',      label: 'Impostazioni',   icon: 'settings' },
    ],
  },
];

export default function Sidebar() {
  const { beach } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logoutAdmin();
    navigate('/login');
  };

  return (
    <aside style={{
      width: '220px', background: 'var(--navy-mid)',
      borderRight: '1px solid var(--border)',
      display: 'flex', flexDirection: 'column', flexShrink: 0,
    }}>
      <div style={{ padding: '24px 20px 20px', borderBottom: '1px solid var(--border)' }}>
        <Logo />
        <div style={{ fontFamily: 'var(--font-serif)', fontSize: '16px', marginTop: '10px' }}>Just Salento</div>
        <div style={{ fontSize: '11px', color: 'var(--text-muted)', letterSpacing: '0.08em', textTransform: 'uppercase', marginTop: '2px' }}>
          Admin Panel
        </div>
      </div>

      <nav style={{ padding: '16px 12px', flex: 1, overflowY: 'auto' }}>
        {NAV_ITEMS.map((group) => (
          <div key={group.section} style={{ marginBottom: '8px' }}>
            <div style={{
              fontSize: '10px', color: 'var(--text-muted)',
              letterSpacing: '0.1em', textTransform: 'uppercase',
              padding: '0 8px', marginBottom: '4px', marginTop: '12px',
            }}>
              {group.section}
            </div>
            {group.items.map((item) => (
              <NavLink key={item.to} to={item.to} style={({ isActive }) => ({
                display: 'flex', alignItems: 'center', gap: '10px',
                padding: '9px 10px', borderRadius: 'var(--radius-md)',
                fontSize: '13.5px',
                color: isActive ? '#fff' : 'var(--text-soft)',
                background: isActive ? 'var(--ocean)' : 'transparent',
                marginBottom: '2px', transition: 'all 0.15s',
                border: `1px solid ${isActive ? 'rgba(31,147,224,0.3)' : 'transparent'}`,
                textDecoration: 'none',
              })}>
                <span style={{ width: '16px', height: '16px', flexShrink: 0, opacity: 0.85 }}>
                  <Icon name={item.icon} />
                </span>
                {item.label}
              </NavLink>
            ))}
          </div>
        ))}
      </nav>

      <div style={{ padding: '12px', borderTop: '1px solid var(--border)' }}>
        {beach && (
          <div style={{
            background: 'var(--surface)', border: '1px solid var(--border)',
            borderRadius: 'var(--radius-md)', padding: '10px 12px', marginBottom: '8px',
          }}>
            <div style={{ fontSize: '10px', color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '4px' }}>
              Stabilimento
            </div>
            <div style={{ fontSize: '13px', fontWeight: 500 }}>{beach.nome}</div>
            <div style={{ fontSize: '11px', color: 'var(--text-muted)', marginTop: '2px' }}>
              {beach.indirizzo?.split(',')[0]}
            </div>
          </div>
        )}
        <button
          onClick={handleLogout}
          style={{
            width: '100%', padding: '8px', borderRadius: 'var(--radius-md)',
            background: 'transparent', border: '1px solid var(--border)',
            color: 'var(--text-muted)', fontSize: '12.5px', cursor: 'pointer',
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px',
            fontFamily: 'var(--font-sans)', transition: 'all 0.15s',
          }}
          onMouseEnter={e => { e.currentTarget.style.color = 'var(--text-soft)'; e.currentTarget.style.borderColor = 'var(--border-mid)'; }}
          onMouseLeave={e => { e.currentTarget.style.color = 'var(--text-muted)'; e.currentTarget.style.borderColor = 'var(--border)'; }}
        >
          <LogoutIcon /> Esci
        </button>
      </div>
    </aside>
  );
}

function Logo() {
  return (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none">
      <circle cx="18" cy="18" r="18" fill="#2A6E7F"/>
      <ellipse cx="18" cy="26" rx="10" ry="4" fill="#F5C842" opacity="0.9"/>
      <path d="M12 22 Q18 14 24 22" stroke="#1f93e0" strokeWidth="1.5" fill="rgba(31,147,224,0.3)"/>
      <line x1="18" y1="22" x2="18" y2="28" stroke="#c4a060" strokeWidth="1.5"/>
      <path d="M12 17 Q18 11 24 17" stroke="white" strokeWidth="1.2" fill="rgba(255,255,255,0.25)"/>
      <circle cx="24" cy="12" r="4" fill="#F5C842" opacity="0.9"/>
    </svg>
  );
}

function Icon({ name }) {
  const icons = {
    grid: <svg viewBox="0 0 16 16" fill="currentColor" width="16" height="16"><rect x="1" y="1" width="6" height="6" rx="1"/><rect x="9" y="1" width="6" height="6" rx="1"/><rect x="1" y="9" width="6" height="6" rx="1"/><rect x="9" y="9" width="6" height="6" rx="1"/></svg>,
    calendar: <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.2" width="16" height="16"><rect x="2" y="3" width="12" height="11" rx="1.5"/><line x1="5" y1="1" x2="5" y2="5" strokeLinecap="round"/><line x1="11" y1="1" x2="11" y2="5" strokeLinecap="round"/><line x1="2" y1="7" x2="14" y2="7"/></svg>,
    beach: <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.2" width="16" height="16"><circle cx="8" cy="6" r="3"/><path d="M2 13 Q8 9 14 13" strokeLinecap="round"/></svg>,
    builder: <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.2" width="16" height="16"><rect x="1" y="1" width="6" height="6" rx="1"/><rect x="9" y="1" width="6" height="6" rx="1"/><rect x="1" y="9" width="6" height="6" rx="1"/><rect x="9" y="9" width="6" height="6" rx="1" strokeDasharray="2 1"/></svg>,
    tag: <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.2" width="16" height="16"><path d="M2 2h6l6 6-6 6-6-6V2z" strokeLinejoin="round"/><circle cx="6" cy="6" r="1" fill="currentColor" stroke="none"/></svg>,
    settings: <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.2" width="16" height="16"><circle cx="8" cy="8" r="2.5"/><path d="M8 1v2M8 13v2M1 8h2M13 8h2M3.05 3.05l1.41 1.41M11.54 11.54l1.41 1.41M3.05 12.95l1.41-1.41M11.54 4.46l1.41-1.41" strokeLinecap="round"/></svg>,
  };
  return icons[name] || null;
}

function LogoutIcon() {
  return (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.2" width="14" height="14">
      <path d="M6 3H3a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h3" strokeLinecap="round"/>
      <path d="M10 5l3 3-3 3M13 8H6" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}
